(function(algolia) {
    'use strict';
  
    if (algolia.config.powered_by) {
      // eslint-disable-next-line no-console
      console.log(
        "You're using Algolia !\n" +
          'Visit https://www.algolia.com/ for more insight about what we do.'
      );
    }
    algolia.base_url = window.location.origin;
    /* Store variables */
    algolia.storeName = window.location.hostname
      .replace(/^www\./, '')
      .replace(/^([^.]*)\..*$/, '$1');
      
    algolia.maxHits = 1000;
    algolia.queryThreshold = 3;
    /**
     * Checks whether we are on the `/search` page
     */
    algolia.full_results = Boolean(window.location.href.match(/\/search/));
  
    /**
     * Checks whether we are on a collection page
     */
    algolia.is_collection_results_page = Boolean(
      // We want to match `/collections/handle` but only if handle != 'all'
      window.location.pathname.match(/(^\/\w{2}\/|^\/|^\/\w{2}-\w{2}\/)collections\/(?!all$)([^/]+)[/]*$/)
      /**
       * To match /collections/handle/handle-two links as well, please use
       * the following regex instead:
       */
      // window.location.pathname.match(/(^\/\w{2}\/|^\/|^\/\w{2}-\w{2}\/)collections\/(?!all)(.*)$/)
    );
  
    /* Hide page content during InstantSearch loading */
    var collectionPageEnabled =
      algolia.is_collection_results_page &&
      algolia.config.instant_search_enabled_on_collection;
    var results_selector = collectionPageEnabled
      ? algolia.config.collection_css_selector
      : algolia.config.results_selector;
    results_selector += ', .algolia-shopify-instantsearch';
  
    if (
      (algolia.full_results && algolia.config.instant_search_enabled) ||
      collectionPageEnabled
    ) {
      algolia.contentHide = new DOMParser().parseFromString(
        '<style>' + results_selector + ' { visibility: hidden }</style>',
        'text/html'
      ).head.firstElementChild;
      document.head.append(algolia.contentHide);
    }
  
    algolia.getTemplate = function getTemplate(name) {
      var el = document.getElementById('template_algolia_' + name);
      return el ? el.innerHTML : '';
    };
  
    // Current collection page ID
    var current_collection_id_string = algolia
      .getTemplate('current_collection_id')
      .replace(/^\s+|\s+$/g, '');
  
    if (current_collection_id_string) {
      try {
        var current_collection_id_object = JSON.parse(
          current_collection_id_string
        );
        algolia.current_collection_id =
          current_collection_id_object.currentCollectionID;
      } catch (error) {
        // Encountered an error while trying to parse the collection ID.
        // This most probably means that we aren't on a collection page.
      }
    }
  
    /* Add CSS block after current script */
    algolia.appendStyle = function appendStyle(content) {
      var scripts = document.getElementsByTagName('script');
      var currentScript = scripts[scripts.length - 1];
      var style = document.createElement('style');
      style.innerHTML = content;
      currentScript.parentNode.insertBefore(style, currentScript.nextSibling);
    };
  
    algolia.assign = function assign(to) {
      for (var i = 1; i < arguments.length; i++) {
        var nextSource = arguments[i];
        for (var nextKey in nextSource) {
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey]; // eslint-disable-line no-param-reassign
          }
        }
      }
      return to;
    };

    algolia.addCents = function addCents(price){
      return price * 100;
    }
    /* Here because we need to ensure we have a fallback with '$ '. */
    algolia.money_format = algolia
      .getTemplate('money_format')
      .replace(/^\s+|\s+$/g, '');
    algolia.formatMoney = function formatMoney(cents) {
      var priceInCents = cents;
  
      /**
       * Uncomment the following block to support Shopify multi currency
       * and convert prices from store currency to the currency selected by
       * the user (aka "presentment" currency).
       * Please note that this relies on the `Shopify.currency` object exposed
       * by Shopify which is an undocumented feature and can change at any time.
       */
      // if (
      //   typeof Shopify !== 'undefined' &&
      //   typeof Shopify.currency !== 'undefined' &&
      //   typeof Shopify.currency.rate !== 'undefined' &&
      //   typeof Shopify.currency.active !== 'undefined'
      // ) {
      //   // Convert to "presentment" currency using the rate provided by Shopify
      //   priceInCents = priceInCents * Shopify.currency.rate;
      //   // Round up to the nearest whole number keeping in accordance with
      //   // the default rounding strategy of Shopify
      //   priceInCents = Math.ceil(priceInCents);
      //
      //   /**
      //    * Shopify uses different rounding strategies for different currencies.
      //    * The logic below might need to be customised based on the active currencies.
      //    * Note: Please only include currencies other than your store currency.
      //    */
      //   // Round up to the 95th cent for EUR
      //   if (Shopify.currency.active === 'EUR') {
      //     priceInCents = parseInt(priceInCents / 100, 10) * 100 + 95;
      //   }
      //   // Round up to the 00th cent for GBP, USD, DKK
      //   else if (
      //     Shopify.currency.active === 'GBP' ||
      //     Shopify.currency.active === 'USD' ||
      //     Shopify.currency.active === 'DKK'
      //   ) {
      //     priceInCents = parseInt(priceInCents / 100, 10) * 100 + 100;
      //   }
      // }
  
      var val = (priceInCents / 100.0).toLocaleString('en', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      var format = algolia.money_format;
  
      // Not necessary, but allows for more risk tolerance if Shopify.formatMoney doesn't work as we want
      var regexp = /^([^{}]*)\{\{amount\}\}([^{}]*)$/;
      if (format.match(regexp)) {
        return format.replace(regexp, '$1' + val + '$2');
      }
  
      regexp = /^([^{}]*)\{\{amount_with_comma_separator\}\}([^{}]*)$/;
      if (format.match(regexp)) {
        var money = val.replace(/[.]/, '|');
        money = money.replace(/[,]/, '.');
        money = money.replace(/[|]/, ',');
        return format.replace(regexp, '$1' + money + '$2');
      }
  
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(priceInCents, format);
      }
  
      return '$' + val;
    };
    algolia.formatPrice = function formatPrice(value) {
      return algolia.formatMoney(Number(value) * 100).replace('.00','');
    };
    // distinct pricing functions
    algolia.getDistinctKey = function getDistinctKey(currentHit){//if extra data is needed return distinct key else return false
      let distinctKey=currentHit.meta?.search?.distinct_key;
      let hasMultipleVariants = currentHit.variants_count>1
      if(distinctKey && !hasMultipleVariants){//display information for distinct products with single variants so distinctKey needs to be checked.
        console.warn(`Algolia - Distinct group of 1 for ${currentHit.title}. Displaying single default price for this product`)
        return false;//dont include in filter for search query. We are looking to update ranges. Single prices should already display.
      }
      if(distinctKey && hasMultipleVariants){
        if(distinctKey.toString().includes('_') || currentHit.meta?.search?.on_sale == true){
          return distinctKey.toString()
        }
      }
      return false;
    };
    algolia.changeDistinctPrices = function changeDistinctPrices(hits,distinctProducts,container){
          if(hits.length===0){
            console.warn("The metafield distinct_key is not in attributesForFaceting in the Algolia Dashboard. Displaying default prices for all products")
            return
          }else if(hits.length===1000){
            console.warn("Returned limits reaches capacity of 1k. Some distinct product prices might not be updated.")
          }
        let productCards = document.querySelector(`.${container}-product-hits`);
        
        distinctProducts.forEach((product)=>{
          let defaultPricesContainer = productCards.querySelector('[data-variant-id="'+product.objectID+'"] .defaultPrice');
          let distinctPricesContainer = productCards.querySelector('[data-variant-id="'+product.objectID+'"] .distinctPrice');
          let distinctCurrentPrice = distinctPricesContainer.querySelector('.algolia-current-price')
          let distinctStrikedPrice = distinctPricesContainer.querySelector('.algolia-striked-price')
          let distinctKey = product.meta?.search?.distinct_key
          if(distinctCurrentPrice && distinctKey){
            let variants = hits.filter((hit)=> hit.meta?.search?.distinct_key === distinctKey);//match distinct key
            let originalPrice=[];
            let currentPrice=[];
            if(variants.length===0){
              console.warn(`No returned hits from Algolia additional query for product ${product.title}`)
              return;
            }
            if(variants.length>1){// only update to range price if there are enough matching hits
              variants.forEach((variant)=>{
                currentPrice.push(variant.price);
                variant.compare_at_price ? originalPrice.push(variant.compare_at_price) : originalPrice.push(variant.price);//store original price , sometimes compare price is empty so use current price. 
              })
              let currentPriceMin = Math.min(...currentPrice), currentPriceMax = Math.max(...currentPrice);
              let updatedCurrentPrice = currentPriceMin===currentPriceMax ? algolia.formatPrice(currentPriceMax) : algolia.formatPrice(currentPriceMin)+' - '+algolia.formatPrice(currentPriceMax);
              distinctCurrentPrice.innerHTML = updatedCurrentPrice;
              let isOnSale = product.meta?.search?.on_sale === true;
              if(distinctStrikedPrice && isOnSale){
                let originalPriceMin = Math.min(...originalPrice), originalPriceMax = Math.max(...originalPrice);
                distinctStrikedPrice.innerHTML = originalPriceMin===originalPriceMax ? algolia.formatPrice(originalPriceMax) : algolia.formatPrice(originalPriceMin)+' - '+algolia.formatPrice(originalPriceMax);
              }
              defaultPricesContainer.classList.add('hidden')
              distinctPricesContainer.classList.remove('hidden')
            }else{
              console.warn(`Algolia - Distinct group of 1 for ${product.title}. Displaying single default price for this product`)
              distinctPricesContainer.classList.add('hidden')
              defaultPricesContainer.classList.remove('hidden')
            }
          }
        })
    }
    algolia.getDistinctProductData = function getDistinctProductData(hits){
      const distinctKeys = [];
      const distinctProducts = [];
      hits.forEach((hit)=>{
        let distinctKey = algolia.getDistinctKey(hit);
        if(distinctKey){
          distinctProducts.push(hit)
          distinctKeys.push(`meta.search.distinct_key:"${distinctKey.replace(/"/g,'\\"')}"`)
        }
      })
      return {distinctProducts,distinctKeys}
    }
    //distinct pricing logic starts here
    algolia.updateDistinctPrices = function updateDistinctPrices(originalHits,index,container){
      /*
      const {distinctProducts,distinctKeys} = algolia.getDistinctProductData(originalHits)
      if(distinctKeys.length===0) return;
      index.search('',{
        filters:distinctKeys.join(' OR '),
        attributesToRetrieve: ['title','id','options','price','compare_at_price','meta'],//restricting attributes to retrieve improves performance
        attributesToHighlight:false,
        attributesToSnippet:false,
        hitsPerPage:algolia.maxHits,//max hits returned per request, subject to change later
        distinct:0,
        analytics:false,
      }).then( 
        ({hits})=> { algolia.changeDistinctPrices(hits,distinctProducts,container)
      },
      (error)=>{
        console.warn('Algolia api call error / displaying default prices')
        console.log(error)
      })
      */
    }
  })(window.algoliaShopify);
  